(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      window.addEventListener('resize', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      const utilityBar = document.querySelector('.announcement-bar-section');
      const utilityBarHeight = utilityBar ? utilityBar.offsetHeight : 0;
      const headerHeight = this.header ? this.header.offsetHeight : 0;

      document.documentElement.style.setProperty('--karigari-utility-bar-height', `${utilityBarHeight}px`);
      document.documentElement.style.setProperty('--header-height', `${utilityBarHeight + headerHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.setHeaderHeight.bind(this));
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const compactThreshold = 24;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > compactThreshold) {
        if (!this.header.classList.contains('karigari-header-compact')) {
          this.header.classList.add('karigari-header-compact', 'scrolled-past-header');
          this.setHeaderHeight();
        }
      } else if (this.header.classList.contains('karigari-header-compact')) {
        this.header.classList.remove('karigari-header-compact', 'scrolled-past-header');
        this.setHeaderHeight();
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) {
          this.currentScrollTop = scrollTop;
          return;
        }
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || document.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  const setUtilityBarHeight = () => {
    const utilityBar = document.querySelector('.announcement-bar-section');
    if (utilityBar) {
      document.documentElement.style.setProperty('--karigari-utility-bar-height', `${utilityBar.offsetHeight}px`);
    }
  };

  const initUtilityBarHeight = () => {
    setUtilityBarHeight();
    requestAnimationFrame(setUtilityBarHeight);
  };

  document.addEventListener('DOMContentLoaded', initUtilityBarHeight);
  window.addEventListener('resize', setUtilityBarHeight);
  window.addEventListener('load', setUtilityBarHeight);

  } catch(e) { console.error(e); }
})();
})();
